import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircleIcon, XCircleIcon } from 'lucide-react';
export function StorySection() {
  return <section className="py-24 bg-white" data-id="element-124">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-125">
        {/* Hook */}
        <FadeIn data-id="element-126">
          <p className="text-body-lg font-serif italic text-navy text-center mb-16 text-2xl leading-relaxed" data-id="element-127">
            "¿Alguna vez has sentido ese pequeño pinchazo de miedo al bajar una
            escalera mecánica o al caminar por una acera que parece un poco
            resbaladiza?"
          </p>
        </FadeIn>

        {/* The Problem */}
        <FadeIn delay={0.1} data-id="element-128">
          <div className="prose prose-lg max-w-none text-body mb-20 space-y-6" data-id="element-129">
            <p data-id="element-130">
              No eres la única. Ese miedo no es una cuestión de "edad", es una
              señal de que tu cuerpo se siente frágil, y tu instinto está
              tratando de protegerte. Pero hay una verdad que nadie te dice: el
              exceso de "cuidado" y el reposo son los que realmente debilitan
              tus huesos.
            </p>
            <p data-id="element-131">
              Tus huesos son tejido vivo; si no les das una razón para ser
              fuertes, tu cuerpo empezará a desmantelarlos.
            </p>
            <div className="bg-cream p-8 rounded-2xl border border-teal/20 my-10" data-id="element-132">
              <h3 className="text-h3 mb-4 flex items-center gap-3" data-id="element-133">
                <AlertCircleIcon className="text-teal w-8 h-8 flex-shrink-0" data-id="element-134" />
                La verdadera amenaza
              </h3>
              <p className="mb-4" data-id="element-135">
                Para una mujer de más de 65 años, una caída no es solo un golpe;
                es la amenaza real de perder la independencia. Has visto a
                amigas o familiares pasar por una fractura de cadera y sabes que
                la vida cambia en un segundo.
              </p>
              <p data-id="element-136">
                Vives midiendo cada paso, evitando actividades que antes amabas
                y sintiendo que tu mundo se hace cada vez más pequeño para
                "evitar riesgos". El miedo a convertirte en una carga para tu
                familia pesa más que cualquier dolor físico.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Why What You Tried Didn't Work */}
        <FadeIn delay={0.2} data-id="element-137">
          <h2 className="text-h2 text-center mb-12" data-id="element-138">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-139">
            {["Los suplementos de calcio solos no funcionan porque sin el 'transporte' adecuado, el calcio termina en tus arterias, no en tus huesos.", 'Caminar 30 minutos es excelente para el corazón, pero no genera la tensión mecánica necesaria para reconstruir masa ósea.', 'Los gimnasios tradicionales son peligrosos porque sus máquinas y ejercicios de impacto no respetan la biología de una mujer senior.', 'El reposo absoluto acelera la pérdida de minerales, convirtiendo tus huesos en estructuras de cristal.'].map((text, i) => <div key={i} className="bg-cream/50 p-6 rounded-xl flex items-start gap-4" data-id="element-140">
                <XCircleIcon className="text-red-400 w-6 h-6 flex-shrink-0 mt-1" data-id="element-141" />
                <p className="text-body" data-id="element-142">{text}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}